/**
 * Stores data in session storage.
 *
 * @param {string} key - The session storage key.
 * @param {unknown} data - The data to be stored, which is of unknown type.
 * @returns {void}
 */
export const setSessionData = (key: string, data: unknown): void => {
  try {
    if (typeof window !== 'undefined') {
      const sessionItem = { data, timestamp: Date.now() };
      sessionStorage.setItem(key, JSON.stringify(sessionItem));
    }
  } catch (error) {
    console.error('Error writing to sessionStorage:', error);
  }
};

export const getSessionData = (key: string): unknown => {
  try {
    if (typeof window !== 'undefined') {
      const sessionItem = sessionStorage.getItem(key);
      return sessionItem ? JSON.parse(sessionItem) : null;
    }
    return null;
  } catch (error) {
    console.error('Error reading from sessionStorage:', error);
    return null;
  }
};

/**
 * Removes data from session storage.
 *
 * @param {string} key - The session storage key.
 * @returns {void}
 */
export const removeSessionData = (key: string): void => {
  try {
    if (typeof window !== 'undefined') {
      sessionStorage.removeItem(key);
    }
  } catch (error) {
    console.error('Error removing from sessionStorage:', error);
  }
};
